import { render, staticRenderFns } from "./articlePreview.vue?vue&type=template&id=a80aff00&scoped=true&"
import script from "./articlePreview.vue?vue&type=script&lang=js&"
export * from "./articlePreview.vue?vue&type=script&lang=js&"
import style0 from "./articlePreview.vue?vue&type=style&index=0&id=a80aff00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a80aff00",
  null
  
)

export default component.exports